<template>
    <v-server-table :url="url" :columns="columns" :options="options" class="trigger" ref="table">
        <template slot="action_name" slot-scope="props">
            {{ props.row.action.name }}
        </template>
        <template slot="due_date" slot-scope="{ row }">
            <span v-if="row.due_date">{{ moment(row.due_date).isValid() ? moment(row.due_date).fromNow() : lang('app.not_calculatable_yet') }}</span>
            <span v-else>{{ lang('app.not_calculatable_yet') }}</span>
        </template>
        <template slot="assigned_role" slot-scope="props">
            {{ props.row.action.assigned_to_role ? props.row.action.assigned_to_role.name : '' }}
        </template>
        <template slot="status" slot-scope="props">
            {{ uLang('app.' + props.row.action_progress_status.name) }}
            <template v-if="isStatus(props.row, 'checking') && props.row.latest_check">
                {{ lang('app.at') }}
                <router-link v-if="props.row.latest_check.checker" :to="{ name: 'admin.relations.view', params: { id: props.row.latest_check.checker.id } }">
                    {{ props.row.latest_check.checker.full_name }}
                </router-link>
                <template v-else>
                    {{ uLang(`app.${ props.row.latest_check.type }`).toLowerCase() }}
                </template>
            </template>
        </template>
        <template slot="action_document" slot-scope="{ row }">
            <div v-if="row.action_document_version_id !== null">
                <link-if
                    :if="(row.action_progress_status.name !== 'skipped' && row.action_progress_status.name !== 'checking') || $hasRole('trajectory_manager') || $hasRole('super_admin')"
                    :to="{
                        name: 'admin.relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.update',
                        params: {
                            relationId: relation.id,
                            trajectoryEnrolmentId: trajectoryEnrolment.id,
                            milestoneProgressId: milestoneProgress.id,
                            actionProgressId: row.id
                        }
                   }"
                >
                    {{ row.action.action_document ? row.action.action_document.name : '' }}
                </link-if>
            </div>
            <span v-else>{{ uLang('app.no_coupled_action_document') }}</span>
        </template>
        <template slot="message" slot-scope="props">
            T.B.I.
        </template>

        <template slot="filter__assigned_role">
            <multi-select :options="roles" :loading="!roles" :deselectLabel="uLang('app.press_enter_to_remove')"
                          :selectLabel="uLang('app.press_enter_to_select')" :selectedLabel="uLang('app.select')"
                          label="name" :placeholder="uLang('app.select_an_option')" @input="searchRole" track-by="name"/>
        </template>
        <template slot="filter__status">
            <multi-select :options="statuses" :loading="!statuses" :deselectLabel="uLang('app.press_enter_to_remove')"
                          :selectLabel="uLang('app.press_enter_to_select')" :selectedLabel="uLang('app.select')"
                          label="translated_name" :placeholder="uLang('app.select_an_option')" @input="searchStatus" track-by="name"/>
        </template>
    </v-server-table>
</template>

<script>
    import { TableMixin } from '~/mixins'
    import MultiSelect from 'vue-multiselect/src/index'
    import Actions from './actions'

    export default {
        name: 'index',
        components: {
            'multi-select': MultiSelect
        },
        mixins: [ TableMixin ],
        props: {
            url: {
                type: String,
                required: true,
                default: null,
            },
            relation: {
                type: Object,
                required: true,
            },
            trajectoryEnrolment: {
                type: Object,
                required: true,
            },
            milestoneProgress: {
                type: Object,
                required: true,
            },
        },

        data () {
            return {
                roles: [],
                statuses: [],
                columns: [
                    'action_name',
                    'due_date',
                    'assigned_role',
                    'status',
                    'action_document',
                    'message',
                    'actions'
                ],
                templates: {
                    actions: Actions,
                },
                filterable: [
                    'action_name',
                    // 'assigned_role',
                    // 'status',
                    'action_document',
                ],
                options: {
                    headings: {
                        action_name: this.uLang('app.action'),
                        due_date: this.uLang('app.expiration_date'),
                        assigned_role: this.uLang('app.role'),
                        status: this.uLang('app.status'),
                        action_document: this.uLang('app.action_document'),
                        message: this.uLang('app.message'),
                        actions: this.uLang('app.actions'),
                    },
                    customFilters: [
                        'assigned_role',
                        'status',
                    ],
                },
            };
        },

        created() {
            this.retrieveRoles();
            this.retrieveStatuses();
        },

        methods: {
            async retrieveRoles() {
                const {data} = await window.axios.get(route('roles.index'));
                this.roles = data;
            },

            async retrieveStatuses() {
                const {data} = await window.axios.get(route('action-progress-statuses.index'));
                this.statuses = data;
            },

            searchRole(role) {
                this.$refs.table.query.role = role !== null ? role.name : '';
                this.$refs.table.refresh();
            },

            searchStatus(status) {
                this.$refs.table.query.status = status !== null ? status.name : '';
                this.$refs.table.refresh();
            },
            isStatus(row, status) {
                return row.action_progress_status.name === status;
            },
        },
    }
</script>

<style lang="css" scoped>
</style>
